/**
 * Formats a possibly large number into an abbreviated form. Eg:
 * - 1000 => 1K
 * - 12000 => 12K
 * - 300000 => 300K
 * - 4000000 => 4M
 * - 5000000000 => 5B
 *
 * Note that for non rounded numbers like 12345 we consense it to just 12K, and
 * not something like 12.34K or 12.3K. The reason being is that in the latter case
 * it'd result in strings with more chars than the original number, ruining the
 * purpose of abbreviating it. For sake of simplicity, we also apply that logic
 * for non-rounded number in the millions or billions.
 *
 * That can be controlled by the `precision` param though.
 */
export function condensedNumber(n, { precision = 0 } = {}) {
  if (!n) return n // includes the case when n = 0

  const { pow, floor, abs, log, min } = Math
  const abbrev = ['', 'K', 'M', 'B']

  const origBase = floor(log(abs(n)) / log(1000))
  const base = min(abbrev.length - 1, origBase)
  const suffix = abbrev[base]
  const abbrevN = base ? round(n / pow(1000, base), precision) : n

  return abbrevN + suffix
}

/**
 * Rounds a decimal number based on precision. Eg:
 * round(1.2345, 2) // => 1.23
 */
export function round(n, precision) {
  const prec = Math.pow(10, precision)
  return Math.round(n * prec) / prec
}
